import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {Icon} from "features/components/icon";
import {max} from "lodash";
import {oneOf} from "prop-types";
import {useMediaQuery} from "services/utils/utils";
import {MOBILE_MEDIA_QUERY_THRESHOLD} from "constants.js";

export const HorizontalScrollSection = (props) => {
    const {children, type} = props;

    const scroller = React.useRef(null);
    const container = React.useRef(null);

    const [width, setWidth] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    const [containerHeight, setContainerHeight] = useState(0);
    const [scrollTo, setScrollTo] = useState(0);

    const [windowWidth, setWindowWidth] = useState(document.querySelector('body').clientWidth);
    /* istanbul ignore next */
    const resizeListener = () => {
        setWindowWidth(document.querySelector('body').clientWidth);
    };
    /* istanbul ignore next */
    React.useEffect(() => {
        window.addEventListener("resize", resizeListener);
        return () => window.removeEventListener("resize", resizeListener);
    });
    const padding = useMemo(() => {
        return windowWidth * 0.025;
    }, [windowWidth]);
    React.useEffect(() => {
        const childrens = scroller.current.children;
        const last_child = childrens[childrens.length - 1]
        const width = last_child.offsetLeft + last_child.offsetWidth;
        setContainerHeight(max(Array.from(childrens).map(i => i.offsetHeight)));
        setWidth(width + padding * 2);
    }, [padding, scroller, windowWidth]);

    React.useEffect(() => {
        setContainerWidth(container.current.offsetWidth);
    }, [container, windowWidth])

    const shouldShowNext = useMemo(() => {
        return width > containerWidth && scrollTo > (width - containerWidth) * -1;
    }, [width, containerWidth, scrollTo]);
    const shouldShowPrev = useMemo(() => {
        return scrollTo < 0;
    }, [scrollTo]);


    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);
    const scrollFactor = useMemo(() => {
        return isMobile ? containerWidth * 0.8 : (containerWidth * 0.5);
    }, [containerWidth, isMobile]);

    const goToRight = useCallback(() => {
        const max = (width - containerWidth) * -1;
        const to = scrollTo - scrollFactor;
        setScrollTo(Math.max(max, to));
    }, [width, containerWidth, scrollTo, scrollFactor]);
    const goToLeft = useCallback(() => {
        const to = scrollTo + scrollFactor;
        setScrollTo(Math.min(to, 0));
    }, [scrollTo, scrollFactor]);

    return <div ref={container} style={{height: containerHeight, width: windowWidth}} className={`horizontal-scroll-section ${type || "dark"}`}>
        <div ref={scroller} style={{width: width, left: scrollTo + padding}} className="scrollable">
            {children}
        </div>
        <div className={`backdrop ${!shouldShowNext ? "hide" : ""}`} />
        <div className={`backdrop backdrop-prev ${!shouldShowPrev ? "hide" : ""}`} />
        {shouldShowNext && <div className="next" onClick={goToRight}><Icon>chevron-right</Icon></div>}
        {shouldShowPrev && <div className="prev" onClick={goToLeft}><Icon>chevron-left</Icon></div>}
    </div>
}
HorizontalScrollSection.propTypes = {
    type: oneOf(["dark", "light"])
}